import { Modal } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledConfirmModal = styled(Modal)`
  * {
    font-size: 15px;
    font-family: ${({ theme }) => theme.fonts.fontBase} !important;
    a,
    a * {
      color: ${({ theme }) => theme.colors.InfinitiLinkColor} !important;
    }
  }

  padding-right: 0 !important;

  .modal-dialog {
    max-width: 600px;
  }

  strong {
    font-weight: 600;
  }

  .modal-body {
    padding: 1rem 1.4rem 1.4rem;
    color: ${({ theme }) => theme.colors.defaultTextColor};
  }

  .modal-header {
    margin: 0.5rem 1rem;
    padding: 0.5rem 1rem 0 !important;
    border-bottom: none;

    button {
      padding: 0;
      span {
        font-size: 25px;
      }
    }
  }

  .modal-warning-message {
    color: red;
  }

  .modal-btn-group {
    text-align: end;
    margin-top: 10px;

    button {
      min-width: 30px;
      font-size: 15px;
    }

    button:not(:first-child) {
      margin-left: 20px;
    }
  }
`
